export enum PageBuilderStructureLabels {
  Module = 'module',
  Page = 'page',
  Area = 'area',
  ComponentName = 'componentName',
  ComponentInstance = 'componentInstance',
}
